var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-container',{attrs:{"fluid":""}},[(_vm.$route.meta.sidebar)?_c('SideBarMenu'):_vm._e(),_c('v-main',[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }